import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import AddNoticeMsg from "../xcpOpsManager/noticeComponent/addNoticeMsg.vue";
import ShowNoticeTable from "./noticeComponent/showNoticeTable.vue";
export default {
  components: {
    AddNoticeMsg: AddNoticeMsg,
    ShowNoticeTable: ShowNoticeTable
  },
  name: "gameNotice",
  data: function data() {
    return {
      ueditorConfig: {
        serverUrl: "/api/cos/upload2cp",
        UEDITOR_HOME_URL: "/UEditor/" // 需要令此处的URL等于对应 ueditor.config.js 中的配置。
      },

      noticeDialog: false,
      noticeInfo: {
        id: 0,
        channel_id: "",
        type: 1,
        title: "",
        content: "",
        start_time: "",
        end_time: "",
        is_pop: 0,
        status: 0
      },
      searchInfo: {
        status: [1, 2, 3] // 1=生效中 2=未生效 3=已过期
      },

      info: {},
      addOrEdit: 1
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    addNoticeBtn: function addNoticeBtn() {
      this.info = this.noticeInfo;
      this.addOrEdit = 1;
      this.noticeDialog = true;
    },
    backNotice: function backNotice(e) {
      this.noticeDialog = e;
      this.queryEvent();
    },
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.searchInfo.status.length == 0)) {
                _context2.next = 3;
                break;
              }
              _this.$message.error("请选择状态");
              return _context2.abrupt("return");
            case 3:
              _this.$refs.myChild.loadTatleData(_this.searchInfo);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    goEditBtn: function goEditBtn(e) {
      this.info = e;
      this.addOrEdit = 2;
      this.noticeDialog = true;
    },
    onTableReady: function onTableReady() {
      this.queryEvent();
    }
  }
};